import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { LoginServiceService } from "../../Services/login-service.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ThrowStmt } from "@angular/compiler";

@Component({
  selector: "login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  public form: FormGroup;
  public loggedIn: boolean;

  constructor(
    private service: LoginServiceService,
    private toastr: ToastrService,
    private _route: Router,
    private spinner: NgxSpinnerService
  ) {
    this.form = this.createFormGroup();
  }

  ngOnInit() {
    if (localStorage.getItem("user")) {
      this.loggedIn = true;
      this._route.navigate(["/home"]);
    } else {
      this.loggedIn = false;
    }
  }

  createFormGroup() {
    return new FormGroup({
      user: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required]),
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  formSubmit() {
    this.spinner.show();
    this.service
      .validateUser(this.form.value.user, this.form.value.password)
      .subscribe(
        (response) => {
          if (response["success"] == "true") {
            this.spinner.hide();
            localStorage.setItem("user", this.form.value.user.toUpperCase());
            this.loggedIn = true;
            // Added this to show the navbar, since B2B check was causing not to load,
            // since the check is on app.component (level above this)
            window.location.reload();
            this._route.navigate(["/home"]);
          } else {
            this.spinner.hide();
            this.toastr.error("Invalid login", "Error");
            this.loggedIn = false;
          }
        },
        (error) => {
          this.spinner.hide();
          this.toastr.error("Unexpected error occurred", "Error", {
            timeOut: 5000,
          });
          this.loggedIn = false;
        }
      );
  }
}
